import {Component, Inject, Input, OnInit} from '@angular/core';
import {SettingsComponent} from '../../settings/settings.component';
import {MatDialog, MatDialogRef} from '@angular/material';
import {AccountInfoService} from '../../user/account-info.service';
import {ConfService} from '../../conf.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {GetPasswordComponent} from '../../settings/connectors/connectors.component';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';
import {interval} from 'rxjs';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {AddApiGatewayNewComponent} from './add-api-gateway-new/add-api-gateway-new.component';
import {AddNewGatewayNewComponent} from './add-new-gateway-new/add-new-gateway-new.component';
import {Router} from "@angular/router";

@Component({
  selector: 'app-api-gateway-settings-new',
  templateUrl: './api-gateway-settings-new.component.html',
  styleUrls: ['./api-gateway-settings-new.component.scss']
})
export class ApiGatewaySettingsNewComponent implements OnInit {
  displayedColumns: string[] = ['name', 'type', 'provider', 'actions'];

  constructor(
      public settingComp: SettingsComponent,
      private dialog: MatDialog,
      public accountInfoService: AccountInfoService,
      public confPost: ConfService,
      public _service: ConnecttocrudService,
      public platform: LeftpanelComponent,
      private adminEnvironmenthandler: AdminEnvironmentHandlerService,
      private partnerSettingsService: PartnerSettingsService,
      public router: Router


) {}

  data: any[] = []; // Initialize as an empty array

  gatewayPayload: any;
  flag: any;
  indexi: any;
  indexj: any;
  @Input() partner: any;
  @Input() partnerKey: any;
  @Input() account: any;
  @Input() payload: any;
  @Input() id: any;
  addConnection = true;
  configurationsGatewayPayload: any;

  dataLoading = true;
  isDataError = false;
  componentLoading = true;
  environment: any;
  dataFlag = true


  getApiGateways() {
    this.dataLoading = true;
    this.isDataError = false;
    this.confPost
        .getAdvancedPartnerSettings(this.partner, this.account, localStorage.getItem('partnerKey'))
        .subscribe(
            (data) => {
              let resp: any;
              resp = data;
              this.configurationsGatewayPayload = resp['apigateway'];
              this.data = this.configurationsGatewayPayload; // Assign fetched data to the data variable
              if (this.data.length===0){
                this.dataFlag = false
              }
              this.dataLoading = false;
              this.isDataError = false;
            },
            (error) => {
              this.dataLoading = false;
              this.isDataError = true;
              this.platform.handleErrorGracefully(error, 'Error while getting list of API Gateways');
            }
        );
  }
  openViewDialog(a) {
    const dialogRef = this.dialog.open(GetPasswordComponent, {
      data: JSON.stringify(this.configurationsGatewayPayload[a]['gateway_configurations']),
      width: 'auto',
      height: 'auto',
    });
  }

  deactivate(a) {
    this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;
    this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, {environments: this.payload}).subscribe(res => {
      if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
        this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
          success['body'][0]['environments'][0] = this.payload[this.indexi];
          this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
            alert('You have successfully deactivated the gateway');
          }, error => {
            alert('Error while deactivation. Please try again after sometime');
          });
        }, error => {
          alert('Error while deactivation. Please try again after sometime');
          this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;
        });
      } else {
        alert('You have successfully deactivated the gateway.');
        this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;

      }
    }, error => {
      alert('Error while deactivating. Please try again after sometime.');
      this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;
    });
  }

  activate(a) {
    this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;
    this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, {environments: this.payload}).subscribe(res => {
      if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
        this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
          success['body'][0]['environments'][0] = this.payload[this.indexi];
          this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
            alert('You have successfully activated the gateway');
          }, error => {
            alert('Error while activation. Please try again after sometime');
          });
        }, error => {
          alert('Error while activation. Please try again after sometime');
          this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;

        });
      } else {
        alert('You have successfully activated the gateway.');
        this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;

      }
    }, error => {
      alert('Error while activating. Please try again after sometime.');
      this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;
    });
  }

  deleteGateway(a) {
    if (confirm('Are you sure you want to delete this gateway connection?')) {
      this.payload[this.indexi]['services'][this.indexj].configurations.splice(a, 1);
      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, this.payload).subscribe(res => {
        if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
          this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
            success['body'][0]['environments'][0] = this.payload[this.indexi];
            this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
              alert('You have successfully deleted the gateway connection');
            }, error => {
              alert('Error while deleting. Please try again after sometime');
            });
          }, error => {
            alert('Error while deleting. Please try again after sometime');
          });
        } else {
          alert('Deletion Successful');
        }
      }, error => {
        alert('Error while deleting. Please try again after sometime.');
      });
    }
  }

  stringifyjson(val) {
    return JSON.stringify(val);
  }

  setData(){    
    this.environment = this.partnerSettingsService.environment;
    this.partner = this.adminEnvironmenthandler.currentEnvironment.env;
    this.account = this.adminEnvironmenthandler.currentEnvironment.env;    
    this.getApiGateways();

  }
  redirect(route: string) {
    this.router.navigate([route]);
  }

  initialize() {
    const refreshTwice = async () => {
      this.setData();
      if (this.data && this.data.length === 0) {
        this.setData();
      }
    };

    const partnerSettingsSubscription = interval(500).subscribe(async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        let environmentData = this.adminEnvironmenthandler.currentEnvironment;
        if (environmentData.env.includes('admin-')) {
          this.redirect('/console');
        } else {
          refreshTwice();
        }

        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          environmentData = this.adminEnvironmenthandler.currentEnvironment;
          if (environmentData.env.includes('admin-')) {
            this.redirect('/console');
          } else {
            refreshTwice();
          }
        });
      }
    });
  }

  ngOnInit() {
    this.setData();
  }


  addGateway() {
    const dialogRef = this.dialog.open(AddApiGatewayNewComponent, {
      width: '60%',
      panelClass: 'dialog-color',
      data: {
        'partner': this.partner,
        'account': this.account,
        'partnerKey': this.partnerKey
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.dataLoading = true;
        setTimeout(() => {
          this.getApiGateways();
        }, 1000);
      }
    });
  }

  updateGateway(data) {

    const dialogRef = this.dialog.open(AddApiGatewayNewComponent, {
      width: '60%',
      data: {
        'partner': this.partner,
        'account': this.account,
        'partnerKey': this.partnerKey,
        'isEdit': true,
        'apigateway': data
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.dataLoading = true;
        setTimeout(() => {
          this.getApiGateways();
        }, 1000);
      }
    });
  }

  deleteGatewayConfig(data) {
    if (confirm('Are you sure you want to delete this gateway connection?')) {
      this.dataLoading = true;
      this.confPost.manageApiGateways(this.partner, this.account, this.partnerKey, 'delete', {
        name: data.name,
        type: data.type,
      }).toPromise().then(response => {
        this.platform.openSnackBar('API Gateway deleted successfully', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        setTimeout(() => {
          this.getApiGateways();
        }, 1000);
      }, error => {
        this.dataLoading = false;
        this.platform.handleErrorGracefully(error, 'Error while deleting API gateway');
      });
    }
  }

  refreshPage(){
    this.initialize()
  }

  openDialog() {
    const dialogRef = this.dialog.open(AddNewGatewayNewComponent, {
      width: '90%',
      data: {
        'payload': this.payload,
        'partner': this.partner,
        'account': this.account
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res !== undefined) {
        this.payload[this.indexi]['services'][this.indexj].configurations.push(res);
        res.status = false;
        res.default = false;
        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, this.payload).subscribe(res => {
          if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
            this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
              success['body'][0]['environments'][0] = this.payload[this.indexi];
              this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
                alert('You have successfully added the gateway connection');
              }, error => {
                alert('Error while adding. Please try again after sometime');
              });
            }, error => {
              alert('Error while adding. Please try again after sometime');
            });
          } else {
            alert('Addition Successful');
          }
        }, error => {
          alert('Error while adding. Please try again after sometime.');
        });
      }
    });
  }

}
